const colourPalette = [
	"#ffeed9",
	"#edadad",
	"#d3ffa3",
	"#c0faf2",
	"#d9dcff",
	"#fadbff",
];

const labelText = ["Todo", "Assigned", "In Progress", "Done"];

export { colourPalette, labelText };
